import { EVENTS } from "@/lib/constants";
import EventCard from "@/components/EventCard";

export default function Events() {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <h2 className="font-['Playfair_Display'] text-4xl text-center mb-16 text-[#4A1D6E]">Upcoming Events</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {EVENTS.map(event => (
            <EventCard
              key={event.id}
              title={event.title}
              date={event.date}
              time={event.time}
              location={event.location}
              image={event.image}
              details={event.details}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
